// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2ee15222","23":"2e30a3a8","172":"983fa6ce","234":"14f97d0f","309":"389adcad","359":"9cb55ed3","835":"e1dcce04","874":"cef30a9e","904":"fdb7a98e","933":"74d518da"}[chunkId] + ".chunk.js";
};